import {Component, OnInit, Injector} from '@angular/core';
import {AppComponentBase} from '../../../services/AppComponentBase';
import {ScannerPrimarySearchList, ScannerInstrumentList, ScannerSide, ScannerChartingStudy} from '../interfaces/scanner.enums';
import {searchTerm} from '../interfaces/scanner.interfaces';
import {scanData} from '../model/scanData';
import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";
import {Point, findSegmentIntersection, Segment, findAllIntersections, findAllIntersectionsReversedWithCrossDirection, PointDirection, findFirstIntersectionsReversedWithCrossDirection} from '../model/Math/intersection.Math';
import {quoteFilterTabsList} from '../../quoteFilterTabs/quoteFilterTabs.list';
import {HistoryItemPeriod} from '../../../interfaces/historyItem';

@Component({
    selector: 'app-scannerTab',
    template: require('./scannerTab.component.html'),
    styles: [require('./scannerTab.component.scss')]
})
export class ScannerTabComponent extends AppComponentBase implements OnInit {

    constructor(injector: Injector) {
        super(injector);

        this.workspace.globaGridMode.runNarrowScanProcess.subscribe(v => {

            this.scanProcess(v);

        })

    }

    ngOnInit() {

        if(this.workspace.mobileMode=="desktop")
        {
            setTimeout(() => {


                $(".scanner-tab").mCustomScrollbar({
                    axis: "y",
                    theme: "inset-3", // "minimal-dark",
                    scrollbarPosition: "outside",
                    alwaysShowScrollbar: 0, // 0,1,2
                    scrollButtons: {
                        enable: true
                    },
                    mouseWheel: {
                        enable: true,
                        scrollAmount: 5
                    }
                });

            }, 1000);
        }
    }


    public get allowAccess(): boolean {
        return this.workspace.allowScannerAccess;
    }

    private _isRunNarrowScan: boolean = false;
    public get isRunNarrowScan(): boolean {
        return this.workspace.isNarrowScanMode;
    }
    // public set isRunNarrowScan ( value: boolean ) {
    //     this._isRunNarrowScan = value;
    // }

    public callBackInfoStorage: string[] = [];

    public previousScanData: string = "";

    public currentScanData: string = "";

    public jsonEqual(a: any, b: any) {
        return a === b;
        //return JSON.stringify(a) === JSON.stringify(b);
    }

    public scanProcess(narrow: any = false) {

        this.currentScanData = JSON.stringify({
            market: this.workspace.scannerSearch_market,
            primarySearch: this.workspace.selectedPrimaryScanner,
            period: this.workspace.scannerSearch_period,
            side: this.workspace.scannerSearch_side,
            study: this.workspace.scannerSearch_chartingstudy,
            rule: this.workspace.scannerCurrentRule,
        })

        console.log("SCANDATA");
        console.log(this.currentScanData)
        console.log(this.previousScanData)

        let isSame: boolean = false;
        if(this.jsonEqual(this.currentScanData, this.previousScanData)) {
            console.log("IDENT");
            isSame = true;
        }
        else {
            console.log("DIFF");
            isSame = false;
        }

        if(!this.processAllowScanRules(narrow)) {
            return;
        }


        this.workspace.processNarrowScan = false
        this.workspace.narrowscanFinished = false;
        if(this.workspace.scanInProgress || !this.workspace.allowScanProcess) {
            return;
        }

        let listToScan: any = [];
        let instrument: any = null;
        let searchrule: searchTerm;
        if(!this.isRunNarrowScan) {

            this.workspace.scanResultList = [];
            this.workspace.scanResultListNarrow = [];

            searchrule = {
                market: this.workspace.scannerSearch_market,
                primary: this.workspace.selectedPrimaryScanner,
                period: this.workspace.scannerSearch_period,
                side: this.workspace.scannerSearch_side,
                rule: this.workspace.scannerCurrentRule
            }

            console.log("searchrule");
            console.log(searchrule);

            instrument = this.workspace.selectedPrimaryScanner;

            listToScan = this.workspace.boxes.filter(v => {


                if(this.workspace.currentProvider!="OANDA")
                {
                   
                     return v.visible && v.Type.toString() == searchrule.market
                }
               else
               {
                   let map =  this.workspace.providerInstruments.map(k=>k.Symbol);
                   return map.indexOf(v.Symbol)>-1 && v.visible && v.Type.toString() == searchrule.market;
               }

            })


        }
        else {
            this.workspace.scanResultListNarrow = [];

            searchrule = {
                market: this.workspace.scannerSearch_market,
                primary: narrow,
                period: this.workspace.scannerSearch_Narrow_period,
                side: this.workspace.scannerSearch_Narrow_side,
                rule: this.workspace.scannerCurrentRule_Narrow
            }

            this.workspace.selectedPrimaryScanner_Narrow = narrow;

            console.log("searchrule");
            console.log(searchrule);
            console.log(this.workspace.scanResultList);

            instrument = narrow;

            listToScan = this.workspace.scanResultList.map((v) => {
                let symbol = v.symbol;
                v.Symbol = symbol;
                return v;
            });

        }

        this.workspace.currentCountToScan = listToScan.length;
        // this.workspace.currentCountToScan = 0;

        if(this.workspace.currentCountToScan == 0) {
            this.workspace.showScanResults = true;
            this.workspace.noResults = true;
            return;
        }

        this.workspace.hardFinish = false;
        switch(instrument) {
            case ScannerPrimarySearchList.SCANNER_WIZARD:
                if(searchrule.rule == "NO" || searchrule.side == "NO" || searchrule.rule == undefined) {
                    return;
                }
                else {
                    this.scannerWizardAction(listToScan, searchrule)
                }

                break;

            case ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS:
                this.scannerEntrySignalsAction(listToScan, searchrule)
                break;

            case ScannerPrimarySearchList.SCANNER_CHARTING:
                this.scannerCharting(listToScan, searchrule)
                break;

            case ScannerPrimarySearchList.SCANNER_TIWIZARD:
                this.scannerTIWizard(listToScan, searchrule)
                break;

        }

        if(!this.isRunNarrowScan) {

            this.workspace.scanResultList = [];
            this.workspace.scanResultListNarrow = [];

        }
        else {
            this.workspace.processNarrowScan = true;
        }


        this.previousScanData = JSON.stringify({
            market: this.workspace.scannerSearch_market,
            primarySearch: this.workspace.selectedPrimaryScanner,
            period: this.workspace.scannerSearch_period,
            side: this.workspace.scannerSearch_side,
            study: this.workspace.scannerSearch_chartingstudy,
            rule: this.workspace.scannerCurrentRule,
        })

        if(!isSame && !this.workspace.showScannerPage) {
            this.workspace.showScannerPage = true;
        }



        this.workspace.scanInProgress = true;
        this.workspace.scanStartTime = new Date().getTime();
        this.workspace.scanFinished = false;
        this.workspace.currentScanMarket = this.workspace.scannerSearch_market;
        

    }

    public processAllowScanRules(narrow: any) {
        if(narrow != false) {
            console.log("NARROW");
            console.log(narrow);
            console.log(this.workspace.scannerCurrentRule_Narrow);
            console.log(this.workspace.scannerSearch_Narrow_chartingstudy);
            console.log(this.workspace.scannerSearch_Narrow_period);

            if(this.workspace.scannerCurrentRule_Narrow == undefined) {
                return false;
            }

            if(narrow != 'scanner_entrysignals') {
                if(this.workspace.scannerSearch_Narrow_period == "NO") {
                    return false
                }

            }

            if(narrow == 'scanner_tiwizard') {
                if(this.workspace.scannerCurrentRule_Narrow.momentum == undefined
                    && this.workspace.scannerCurrentRule_Narrow.volatility == undefined
                    && this.workspace.scannerCurrentRule_Narrow.buyingselling == undefined) {
                    return false
                }

            }

            if(narrow == 'scanner_entrysignals') {
                if(this.workspace.scannerCurrentRule_Narrow.LData.direction == undefined
                    && this.workspace.scannerCurrentRule_Narrow.MData.direction == undefined
                    && this.workspace.scannerCurrentRule_Narrow.SData.direction == undefined
                    && this.workspace.scannerCurrentRule_Narrow.EData.direction == undefined) {
                    return false
                }

            }

            if(narrow == 'scanner_charting') {
                if(this.workspace.scannerSearch_Narrow_chartingstudy == "") {
                    return false
                }
            }

            console.log('canScan');
            this.workspace.allowScanProcess = true;
            //return;
            //this.isRunNarrowScan = true;
            return this.workspace.allowScanProcess;
        }
        else {
            if(this.workspace.scannerCurrentRule == undefined) {
                return false;
            }



            if(this.workspace.selectedPrimaryScanner == ScannerPrimarySearchList.SCANNER_WIZARD) {
                if(this.workspace.scannerSearch_period != "NO" && this.workspace.scannerSearch_side != "NO") {
                    this.workspace.allowScanProcess = true;
                }

                if(this.workspace.scannerCurrentRule.selectedPoints == undefined || this.workspace.scannerCurrentRule.selectedPoints == 0) {
                    this.workspace.allowScanProcess = false;
                }


            }


            if(this.workspace.selectedPrimaryScanner == ScannerPrimarySearchList.SCANNER_CHARTING) {
                if(this.workspace.scannerSearch_period != "NO" && this.workspace.scannerSearch_side != "NO" && this.workspace.scannerSearch_chartingstudy != "") {
                    this.workspace.allowScanProcess = true;
                }
            }


            // this.isRunNarrowScan = false;
            return this.workspace.allowScanProcess;
        }

    }


    public scannerWizardAction(listToScan: any, searchrule: any) {
        listToScan.forEach((element: any) => {

            console.log("xSCAN + " + element)
            let symbol = element.Symbol;
            let scan = new scanData(this.dataService, this.workspace, symbol, 200, ScannerInstrumentList.SCANNER_CHWIZARD);
            scan.selectedPeriod = searchrule.period;

            if(this.isRunNarrowScan) {
                scan.narrowScan = true
            }

            if(searchrule.side == ScannerSide.SCANNER_SIDE_BUY) {
                scan.ModeChWizard = "HIGH";
            }
            if(searchrule.side == ScannerSide.SCANNER_SIDE_SELL) {
                scan.ModeChWizard = "LOW";
            }

            scan.init();

        });



        console.log(this.workspace.currentCountToScan);
    }


    public scannerTIWizard(listToScan: any, searchrule: any) {



        listToScan.forEach((element: any) => {

            console.log("TISCAN " + element.Symbol)

            let symbol = element.Symbol;
            let scan = new scanData(this.dataService, this.workspace, symbol, 200, ScannerInstrumentList.SCANNER_TIWIZARD);
            scan.selectedPeriod = searchrule.period;
            scan.tiRule = searchrule.rule;
            if(this.isRunNarrowScan) {
                scan.narrowScan = true
            }
            scan.init();

        });


        console.log(this.workspace.currentCountToScan);
    }

    public scannerEntrySignalsAction(listToScan: any, searchrule: any) {
        listToScan.forEach((element: any) => {

            //  let symbol = "AUD/JPY";
            //    this.workspace.currentCountToScan = 1;
            let symbol = element.Symbol;
            let scan = new scanData(this.dataService, this.workspace, symbol, 200, ScannerInstrumentList.SCANNER_ENTRYSIGNALS);
            if(!this.workspace.isNarrowScanMode) {
                scan.entrySignalperiodsList = this.workspace.scannerCurrentRule;
            } else {
                scan.narrowScan = true
                scan.entrySignalperiodsList = this.workspace.scannerCurrentRule_Narrow;
            }
            scan.init();

        });

    }


    public scannerCharting(listToScan: any, searchrule: any) {

        let instrument = this.workspace.scannerSearch_chartingstudy

        if(this.isRunNarrowScan) {
            instrument = this.workspace.scannerSearch_Narrow_chartingstudy;
        }


        switch(instrument) {
            case ScannerChartingStudy.SCANNER_RSI:

                console.log("ScannerChartingStudy.SCANNER_RSI");
                console.log(searchrule);
                listToScan.forEach((element: any) => {
                    let symbol = element.Symbol;
                    let scan = new scanData(this.dataService, this.workspace, symbol, 200, ScannerInstrumentList.SCANNER_CHARTING_RSI);
                    scan.selectedPeriod = searchrule.period;
                    scan.rsiRule = searchrule.rule;
                    if(this.isRunNarrowScan) {
                        scan.narrowScan = true
                    }
                //    scan.requestForData();

                    scan.init();


                })

                break;

            case ScannerChartingStudy.SCANNER_BOLLINGERBANDS:
                console.log("ScannerChartingStudy.SCANNER_BOLLINGERBANDS");
                console.log(searchrule);
                listToScan.forEach((element: any) => {
                    let symbol = element.Symbol;
                    //    let symbol = "AUD/JPY";
                    let scan = new scanData(this.dataService, this.workspace, symbol, 200, ScannerInstrumentList.SCANNER_CHARTING_BOLLINGERBANDS);
                    scan.bbRule = searchrule.rule;
                    scan.selectedPeriod = searchrule.period;
                    if(this.isRunNarrowScan) {
                        scan.narrowScan = true
                    }
                    scan.init();
                })
                break;

            case ScannerChartingStudy.SCANNER_EMA:
                console.log("ScannerChartingStudy.SCANNEREMA");
                listToScan.forEach((element: any) => {
                    let symbol = element.Symbol;
                    let scan = new scanData(this.dataService, this.workspace, symbol, 200, ScannerInstrumentList.SCANNER_CHARTING_EMA);
                    scan.selectedPeriod = searchrule.period;
                    scan.emaRule = searchrule.rule;
                    if(this.isRunNarrowScan) {
                        scan.narrowScan = true
                    }
                    scan.init();
                })
                break;

            case ScannerChartingStudy.SCANNER_MACD:
                console.log("ScannerChartingStudy.MACD");
                console.log(searchrule);
                listToScan.forEach((element: any) => {
                    let symbol = element.Symbol;
                    let scan = new scanData(this.dataService, this.workspace, symbol, 200, ScannerInstrumentList.SCANNER_CHARTING_MACD);
                    scan.selectedPeriod = searchrule.period;
                    scan.macdRule = searchrule.rule;
                    if(this.isRunNarrowScan) {
                        scan.narrowScan = true
                    }
                    scan.init();
                })
                break;

        }
    }

    public get canScan() {
        return this.workspace.isNarrowScanMode ? false : this.processAllowScanRules(false);
    }


    public get canSave() {
        if(this.workspace.selectedSavedScan == "" && this.processAllowScanRules(false)) {
            return true
        }

        if(this.workspace.selectedSavedScan != "" && this.processAllowScanRules(false) && this.workspace.canSelectedSavedScanUpdate) {
            return true;
        }

        return false;
    }




    public saveScan() {
        if(this.canSave) {
            this.workspace.globaGridMode.fullScreenScanerAction.next("saveScan");
        }

    }


    public ScannerPrimarySearchList = ScannerPrimarySearchList;
    public ScannerChartingStudy = ScannerChartingStudy;

}
